import React from 'react';

const LandingSubText = ({ children, additionalclasses }) => {
    return (
        <p className={`custom-text-white-50 text-[16px] leading-[24px] text-center ${additionalclasses}`}>
            {children}
        </p>
    );
};

export default LandingSubText;